module.exports = __webpack_public_path__ + "img/soft-bg-4-dark.8d02c290.png";